// components/GlobalTextHighlighter.js
import { useEffect } from 'react';
import { useSearch } from '../contexts/SearchContext';

export default function GlobalTextHighlighter() {
  const { searchTerm } = useSearch();

  useEffect(() => {
    // Clear existing highlights first
    const unmarkAll = () => {
      document.querySelectorAll('mark[data-search-highlight]').forEach((el) => {
        const parent = el.parentNode;
        if (parent) {
          parent.replaceChild(document.createTextNode(el.textContent), el);
          parent.normalize();
        }
      });
    };

    const highlightText = (node) => {
      const walk = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null, false);
      const textNodes = [];

      while (walk.nextNode()) {
        const currentNode = walk.currentNode;
        if (
          currentNode.parentNode &&
          currentNode.nodeValue.trim().length > 0 &&
          !['SCRIPT', 'STYLE', 'MARK', 'TEXTAREA', 'INPUT'].includes(currentNode.parentNode.nodeName)
        ) {
          textNodes.push(currentNode);
        }
      }

      const regex = new RegExp(`(${searchTerm})`, 'gi');

      textNodes.forEach((textNode) => {
        const { nodeValue } = textNode;
        if (regex.test(nodeValue)) {
          const span = document.createElement('span');
          span.innerHTML = nodeValue.replace(regex, '<mark data-search-highlight style="background: yellow; padding: 0 2px;">$1</mark>');
          textNode.parentNode.replaceChild(span, textNode);
        }
      });
    };

    unmarkAll();
    if (searchTerm.trim() !== '') {
      highlightText(document.body);
    }

    // Cleanup when unmounted or searchTerm changes
    return () => {
      unmarkAll();
    };
  }, [searchTerm]);

  return null;
}
